import { Address } from "projects/c1-backend/src/app/db/address";


export class FilterDossier{
    name:string="";
    value:string="";
    condition:string="=";
    field:any={};
    nextCondition:string="AND";
  }

export class Dossier{
    id:number;
    id_type!:number;
    id_address!:number;
    title!:string;
    state:number;
    description!:string;
    date!:string;
    note!:string;
    amount!:number;
    tax!:number;
    phases!:DossierPhase[];
    id_current_phase!:number;
    id_user!:number;
    username!:string;
    addressItem!:Address
    log!:[];
    files!:[];
    code!:string;
    users!:any[];
    notes!:[];
    errors!:any;

    constructor(){
        this.id=0;
        this.state=1;
        
    }
}


export class DossierPhase{
    id:number;
    id_type:number;
    title:string;
    description:string;
    access:number;
    id_parent:number;
    sections:any;
    alarms:any;

}


export class DossierField{
    id:number;
    id_phase:number;
    name:string;
    label:string;
    description:string;
    type:string;
    params:any;
    access:number;
    ordering:number;
    
}

export class DossierOverview{
    id:number;
    id_type:number;
    name:string;
    description:string;
    params:any;
}